import React from 'react';
import langConf from "../js/lang";
import LanguageDropdown from './LanguageDropdown';
import './style.css';
import sheleg from '../api/sheleg';
import shelegApi from '../api/shelegApi';

class App extends React.Component {
    state = { 
        language: 'hebrew',
        sessionId: '',
        logo: '',
        currentURL: window.location.href,
        subjects: [],
        slgCustId: this.querystring('v')[0], //7
        //logoVisible: this.querystring('logo'),
        pageNo: this.querystring('pn')[0], //1
        topLogo: '',
        bottomLogo: '',
        topHeading: '',
        bottomHeading: ''
}

    changeLanguage = async (language) => {
        // Languages: hebrew, english
        //console.log('language: ', language);
        if (language === 'hebrew' || language === 'english'){
            this.setState({language: language});
        }
    };

    changeSessionId = async (sessionId) => {
        this.setState({sessionId: sessionId});
    };

    changeLogo = async (location, logoFile) => {
        if (location === 'top')
            this.setState({topLogo: logoFile});
        else if (location === 'bottom')
            this.setState({bottomLogo: logoFile});
    };

    changeHeading = async (location, heading) => {
        if (location === 'top')
            this.setState({topHeading: heading});
        else if (location === 'bottom')
            this.setState({bottomHeading: heading});
    };

    changeSubjects = async (subjects) => {
        this.setState({subjects: subjects});
    };

    validateEmail(email) 
    {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
        {
            return true;
        }
        return false;
    };

    validatePhone(phone)
    {
        var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        if((phone.match(phoneno)))
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    validate = async () => {
        let lang = this.state.language;
        let fullName = document.querySelector('#fullName').value;
        let mobile = document.querySelector('#mobile').value;
        let email = document.querySelector('#email').value;
        let subject = document.querySelector('#subject').value;
        let description = document.querySelector('#description').value;
        let firstName = fullName.split(' ', 1)[0];
        let lastName = fullName.split(' ', 2)[1];
        mobile = mobile.replace('-', '');
        email = email.toLowerCase();
        let ServiceCallPkg = {
            slgCustId: this.state.slgCustId,
            srcId: this.state.slgCustId,
            vendCustId: this.state.slgCustId,
            university: 1,
            firstName: firstName,
            lastName: lastName,
            email: email,
            mobile: mobile,
            subject: subject,
            description: description,
            empNo: 1,
            leadType: 1
        }
        //  console.log('ServiceCallPkg: ', ServiceCallPkg);
        //  console.log('fullName: ',fullName);
        // console.log('mobile: ',mobile);
        // console.log('email: ',email);
        //  console.log('subject: ', subject);
        //  console.log('description: ',description);
        if (email === '' || mobile === '' || fullName === '' || description === '') {
            window.alert(langConf[lang].emptySignup);
            return false;
        }
        if (!this.validatePhone(mobile)){
            window.alert(langConf[lang].illegalPhone);
            return false;
        }
        if (!this.validateEmail(email)){
            window.alert(langConf[lang].illegalEmail);
            return false;
        }
        if (subject === "0"){
            window.alert(langConf[lang].chooseSubject);
            return false;
        }
        let params = ServiceCallPkg;
        let response = await sheleg.post('/AddCall', params);
        //console.log('response.data: ', response.data);
        if (response.data.rslt){
            alert(langConf[lang].success);
            this.clearFields();
        }
        else {
            alert(langConf[lang].unexpectedError);
        }
    }

    handleLogoClick = async (event) => {
        event.preventDefault();
    };

    handleSendClick = async (event) => {
        event.preventDefault();
        this.validate();
    };

    clearFields() {
        document.querySelector('#fullName').value = '';
        document.querySelector('#mobile').value = '';
        document.querySelector('#email').value = '';
        document.querySelector('#subject').value = 0;
        document.querySelector('#description').value = '';
    };

    querystring(obj) {  
        const result = [];
        let match;
        const re = new RegExp('(?:\\?|&)' + obj + '=(.*?)(?=&|$)', 'gi');
        while ((match = re.exec(document.location.search)) !== null) {
            result.push(match[1]);
        }
        return result;
    }

    componentDidMount = async () => {
        let date = new Date();
        //console.log('v=', this.querystring('v')[0]);
        //console.log('logo=', this.querystring('logo')[0]);
        let sessionId = '';
        let logo = '';
        let subjects = [];
        let sessionidPkg = {slgcustId: this.state.slgCustId, appId: 'ServiceCall', pwd: ((date.getDate() * date.getFullYear())-(date.getMonth() + 1)).toString(), userNo: 1};
        let response = await sheleg.post('/GetSessionId/', sessionidPkg);
        //console.log('sessionId: ', response.data);
        sessionId = response.data;
        response = await sheleg.get(`logoFile/${sessionId}`);
        //console.log('logoFile: ', response.data);
        logo = response.data;
        response = await sheleg.get(`/SubjectsList/${sessionId}`);
        subjects.push({subjectCode: 0, subjectHebDescription: langConf['hebrew'].subject, subjectEngDescription: langConf['english'].subject});
        response.data.map((subject) =>  subjects.push(subject));
        //console.log('subjects: ', subjects);
        this.changeSubjects(subjects);
        this.changeSessionId(sessionId);
        //this.changeLogo(logo);
        response = await shelegApi.get(`LandingPage/${sessionId}/${this.state.pageNo}`);
        //console.log('response.data: ', response.data);
        this.changeHeading('top', response.data.pageTopHeader);
        this.changeLogo('top', response.data.topPicUrl);
        this.changeHeading('bottom', response.data.pageBottomHeader);
        this.changeLogo('bottom', response.data.bottomPicUrl);
    };

    render() {
        let lang = this.state.language;
        let dir = langConf[lang].dir;
        let counter = 0;
        let subs = this.state.subjects;
        const subjects = subs.map((subject) => { counter++; return <option key={counter} value={subject.subjectCode}>{lang=== 'hebrew' ? subject.subjectHebDescription : subject.subjectEngDescription}</option>; });
        return (
            <div dir={dir} className="col-12" style={{margin: 'auto', display: 'block'}}>
                <div className="row col-12">
                    <div className="col-5 col-xs-2"></div>
                    <div className="col-2 col-xs-8">
                        <a className={`ui logo icon image ${lang}`} href={this.state.currentURL} style={this.state.topLogo === '' ? {display: 'none'} : {display: 'inline-block', width: '100%'} } onClick={this.handleLogoClick}>
                            <img src={this.state.topLogo} alt="logo"/>
                        </a>
                    </div>
                    <div className="col-5 col-xs-2"></div>
                </div>
                <div className="row col-12">
                    <div className="col-12 col-xs-12">
                        <h1 style={{padding: '1% 4.25%'}}>{this.state.topHeading}</h1>
                    </div>
                </div>
                <br />
                <div className="row col-12">
                    <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    <div className="col-2 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                        <div className={`ui big input field full-name ${lang}`} dir={dir}>
                            <label className={`label full-name ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].fullName}</label>
                            <input id='fullName' type='text' className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'right'}}></input>
                        </div>
                    </div>
                    <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                </div>
                
                <div className="row col-12">
                <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    <div className="col-2 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                        <div className={`ui big input field mobile ${lang}`} dir={dir} >
                            <label className={`label mobile ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].mobile}</label>
                            <input id='mobile' type='tel' className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'left'}}></input>
                        </div>
                    </div>
                    <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                </div>
                    <div className="row col-12">
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                        <div className="col-2 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`ui big input field email ${lang}`} dir={dir} style={{textAlign: 'right'}}>
                                <label className={`label email ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].email}</label>
                                <input id='email' type='email' className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{textAlign: 'left'}}></input>
                            </div>
                        </div>
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    </div>
                    <div className="row col-12">
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                        <div className="col-2 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`ui field subject search big ${lang}`} dir={dir} style={{textAlign: 'right'}}>
                                <label className={`label subject ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`}>{langConf[lang].subject}</label>
                                <select id='subject' className={`ui search dropdown col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{textAlign: 'right'}}>{subjects}</select>
                            </div>
                        </div>
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    </div>
                    <div className="row col-12 col-xs-12">
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                        <div className="col-2 col-xs-12 col-sm-6 col-md-6 col-lg-4">
                            <div className={`ui big input field description ${lang}`} dir={dir} style={{textAlign: 'right'}}>
                                <label className={`label description ${lang} col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12`} style={{float: 'right'}}>{langConf[lang].description}</label>
                                <textarea id='description' className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{height: '150px', textAlign: 'right'}}></textarea>
                            </div>
                        </div>
                        <div className="col-5 col-xs-0 col-sm-3 col-md-3 col-lg-4"></div>
                    </div>
                    <div className="row col-12 col-xs-12">
                        <div className="col-12 col-xs-12">
                            <button className={`ui vertical green animated button submit ${lang}`} style={{marginTop: '10px', marginBottom: '10px'}} onClick={this.handleSendClick}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`${langConf[lang].send}`}</button>
                        </div>
                    </div>
                    <div className="row col-12">
                    <div className="col-12 col-xs-12">
                        <h1 style={{padding: '1% 4.25%'}}>{this.state.bottomHeading}</h1>
                    </div>
                    </div>
                    <div className="row col-12">
                        <div className="col-5 col-xs-2"></div>
                        <div className="col-2 col-xs-8">
                            <a className={`ui logo icon image ${lang}`} href={this.state.currentURL} style={this.state.bottomLogo === '' ? {display: 'none'} : {display: 'block'} } onClick={this.handleLogoClick}>
                                <img className={`logo ${lang}`} src={this.state.bottomLogo} alt="logo"/>
                            </a>
                        </div>
                        <div className="col-5 col-xs-2"></div>
                    </div>
            </div>
        );
    };
}

export default App;
